module.exports = __webpack_public_path__ + "static/top-1b13f73d7860548c81ce04bb4ee26291.png";